import cn from 'classnames'
import * as React from 'react'

import styles from './parallax-image.module.scss'

interface IParallaxImgProps {
  imageSrc: string
  className?: string
}
const ParallaxImg = ({ className, imageSrc }: IParallaxImgProps) => (
  <div className={cn([styles.root, className])} style={{ backgroundImage: `url("${imageSrc}")` }} />
)

export default ParallaxImg
